import http from './http-util';
import config from './config';
import common from './common-util';

class dealer {

    static sendADF = async function (event) {

        
        let dealerId = window.tgDealerId;
        let inputdata = this.getCustomerInfoFromSession();
        let userId = await dealer.getDefaultUser(dealerId);
        let salespersonName = window.tgVChatJoinedOwnerName;
        let participant = this.getParticipant();
        let chatScript = "";
        let roomId = null;
        var chatMessages =[];
        if (event && event.data && event.data.chatMessages) {
            chatMessages = event.data.chatMessages;
            roomId = event.data.roomId;
            if (chatMessages.length > 0) {
                chatScript = this.formatChatMessages(inputdata, chatMessages, salespersonName);
            }
        }
        console.log("ChatScript:" + chatScript);
        if (participant) {
            salespersonName = participant.name;
            userId = participant.userId;
        }

        let comment = "Lead from tagrail video chat";

        if (salespersonName) {
            comment = "Lead from tagrail video chat with " + salespersonName;
        }
        if (chatScript) {
            comment += chatScript;
        }
        if (!inputdata) {
            inputdata = {};
        }


        let deal_guid = "";
        let firstName = "";
        let lastName = "";
        let email = "";
        let phone = "";
        let address = "";
        let city = "";
        let state = "";
        let zipCode = "";
        let street = "";
        let country = "";
        let vin = "";

        firstName = inputdata.customer.fName;
        lastName = inputdata.customer.lName;
        email = inputdata.customer.email;
        phone = inputdata.customer.phone;

        if (inputdata.source === "v3") {

            userId = inputdata.default_user;
            deal_guid = inputdata.deal_guid;
            address = inputdata.customer.location;
            city = inputdata.customer.city;
            state = inputdata.customer.state;
            zipCode = inputdata.customer.zipCode;
            street = inputdata.customer.street;
            country = inputdata.customer.country;
            vin = inputdata.vehicle.vin;
        }

        if (inputdata && (firstName && lastName && (email || phone))) {
            let adfInput = {
                "dealer_id": dealerId,
                "phone": phone,
                "email": email,
                "first_name": firstName,
                "last_name": lastName,
                "full_name": firstName + " " + lastName,
                "user_id": userId,
                "lead_id": "",
                "vin": vin,
                "reason": comment,
                "appointment_date": "",
                "address": {
                    "address": address,
                    "city": city,
                    "state": state,
                    "postal": zipCode,
                    "country": country,
                    "street": street
                },
                "req_type": "",
                "lead_source": "",
                "deal_guid": deal_guid,
                "deal_id": "",
                "adf_source": "Tagrail Video Chat"
            };

            await this.saveChatScript(adfInput, roomId, chatScript, chatMessages, salespersonName);
            
            let adfResponse = await http.post(config.APIBASEURL + "/v1/mail/sendadf/" + dealerId, adfInput);

            return adfResponse;

        }
    }

    static isPopupActive = function () {
        let isActive = false;
        let popupActive = document.querySelector("[tgiframeactive]");
        if (popupActive) {
            let active = popupActive.getAttribute("tgiframeactive");

            if (active === "1") {
                isActive = true;
            }

        }

        return isActive;
    }


    static getCustomerInfoFromSession() {
        var details = JSON.parse(sessionStorage.getItem("tg-chat-customer"));
        return details;
    }

    static setCustomerInSession(eventdata) {
        sessionStorage.setItem("tg-chat-customer", JSON.stringify(eventdata));
    }


    static getChatClientSettings() {
        let settings = JSON.parse(sessionStorage.getItem("tg-vc-ui-settings"));
        return settings;
    }

    static async getChatClientSettingsAsync(dealerId) {
        let settings = this.getChatClientSettings();
        if (settings) {
            return settings;
        } else {

            let response = await http.get(config.APIBASEURL + "/v1/chat/client/settings/" + dealerId);
            if (response && response.success === 1) {
                sessionStorage.setItem("tg-vc-ui-settings", JSON.stringify(response.result));
                settings = response.result;
                return settings;
            }
        }
    }

    static async getDefaultUser(dealerId) {
        let key = "tg-default-user-" + dealerId;
        let defaultUser = sessionStorage.getItem(key);
        if (defaultUser) {
            return defaultUser;
        } else {

            let response = await http.get(config.APIBASEURL + "/v1/dealer/" + dealerId + "/default/user");
            if (response && response.success === 1) {
                let userId = response.result.userId;
                sessionStorage.setItem(key, userId);
                return userId;
            }
        }
    }

    static getParticipant() {
        let participant = sessionStorage.getItem("tg-chat-participant");
        let participantUserId = sessionStorage.getItem("tg-chat-joined-userId");

        return {

            name: participant,
            userId: participantUserId
        };
    }

    static createChatSessionId() {
        let sessionId = sessionStorage.getItem("tg-chat-sessionId");
        if (!sessionId) {
            sessionId = common.generateSessionId();
            sessionStorage.setItem("tg-chat-sessionId", sessionId);
        }
    }

    static getChatSessionId() {
        let sessionId = sessionStorage.getItem("tg-chat-sessionId");
        return sessionId;
    }

    static formatChatMessages(leadInfo, chatMessages, salespersonName) {
        let firstName = leadInfo.customer.fName;
        let lastName = leadInfo.customer.lName;
        let email = leadInfo.customer.email;
        let phone = leadInfo.customer.phone;
        let startDate = new Date(chatMessages[0].createdAt).toDateString();
        let startTime = new Date(chatMessages[0].createdAt).toLocaleTimeString();
        let chatScript = "\nTranscript:";
        chatScript += "\nStart time: " + startDate + " " + startTime + "\n";
        chatScript += "\nAgent: " + salespersonName;
        chatScript += "\nName: " + firstName + " " + lastName;
        chatScript += "\nEmail: " + (email ? email : "NA");
        chatScript += "\nPhone: " + (phone ? phone : "NA");
        chatScript += "\n";
        chatMessages.forEach(message => {
            var time = new Date(message.createdAt).toLocaleTimeString();
            chatScript += "\n[" + time + "] " + message.userName + ": " + message.body;
        });
        chatScript += "\n\n";
        return chatScript;
    }

    static saveChatScript = async function (leadInfo, roomId, chatScript, chatMessages, agent) {
        let saveChatScriptResponse = null;
        if (chatScript && chatScript !== "") {
            let sessionId = common.generateSessionId(); //generates random sessionId
            let source = "standalone-vc-app";
            let dealerId = window.tgDealerId;
            if(window.tgSessionId)
            {
                sessionId = window.tgSessionId;
                source = "v3";
            }
            let chatSessionId = this.getChatSessionId();

            let saveChatScriptInput = {

                dealerId     : dealerId,
                sessionId    : sessionId,
                chatSessionId: chatSessionId,
                roomId       : roomId,
                transcript   : chatScript,
                chatMessages : chatMessages,
                source       : source,
                agent        : agent,
                createdDate  : chatMessages[0].createdAt
            };

            saveChatScriptResponse = await http.post(config.APIBASEURL + "/v1/chat/save/chatscript/" + dealerId, saveChatScriptInput);

            saveChatScriptInput.leadInfo = leadInfo;

            saveChatScriptResponse = await http.post(config.APIBASEURL + "/v1/lead/"+dealerId+"/sdchatleadpush",saveChatScriptInput);

            console.log("ChatScript saved");
        }

        return saveChatScriptResponse;

    }

}

export default dealer;